import { Injectable } from '@angular/core';
import { Menu, MenuItem } from '@app/models/menu.model';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  isBoard(menuItem: MenuItem): boolean {
    return menuItem.name === '掲示板';
  }

  hasTitles(menuItem: MenuItem): boolean {
    return !!menuItem.chkTtls && menuItem.chkTtls.length > 0;
  }

  getMenuItem(
    menuList: Menu[]
  ): (
    menuGroupId: string | null,
    menuid: string | null,
    type: string | null
  ) => MenuItem | undefined {
    return (menuGroupId, menuid, type) => {
      return menuList
        .find((menu) => menu.menuGroupId === menuGroupId)
        ?.menus.find((item) => item.id === menuid && isType(item, type));
    };
  }
}

const isType = (item: MenuItem, type: string | null): boolean =>
  (type === 'ctype' && !!item.ctype) || (type === 'action' && !!item.action);
